export default function Modal({
    showHeader=true,
    modalTitle="",
    handleCloseModal=() => {},
    children,
    footerButton=true,
    footerAction=() => {},
    footerActionActive = false,
    footerActionText = "Continue",
    className=""
}) {
    return (
        <div className={"modal fade show "+className} style={{ display: "block" }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className={"modal-header " + (!showHeader ? "border-0" : "")}>
                        <h5 className="modal-title">{modalTitle}</h5>
                        <button
                            type="button"
                            className="close"
                            onClick={handleCloseModal}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20.055"
                                height="20.055"
                                viewBox="0 0 20.055 20.055"
                            >
                                <path
                                    id="Icon_metro-cross"
                                    data-name="Icon metro-cross"
                                    d="M19.424,15.592h0l-5.16-5.16,5.16-5.16h0a.533.533,0,0,0,0-.752L16.986,2.083a.533.533,0,0,0-.752,0h0l-5.16,5.16-5.16-5.16h0a.533.533,0,0,0-.751,0L2.726,4.521a.533.533,0,0,0,0,.751h0l5.16,5.16-5.16,5.16h0a.533.533,0,0,0,0,.751l2.437,2.437a.533.533,0,0,0,.752,0h0l5.16-5.16,5.16,5.16h0a.533.533,0,0,0,.751,0l2.437-2.437a.533.533,0,0,0,0-.751Z"
                                    transform="translate(-1.047 -0.405)"
                                    fill="#333"
                                    stroke="#fff"
                                    strokeWidth="3"
                                />
                            </svg>
                        </button>
                    </div>
                    <div className="modal-body">
                        {children}
                    </div>
                    {footerButton && <div className="modal-footer">
                        <button
                            type="button"
                            className={"btn backbtn " + (!footerActionActive ? " btn-disabled" : " btn-primary ")} 
                            onClick={footerAction}
                            disabled={!footerActionActive}
                        >
                            {footerActionText}
                        </button>
                    </div>}
                </div>
            </div>
        </div>
    )
}
